<div class="eiq-summary-boxes">
  <div *ngFor="let summaryBox of summaryBoxes" class="eiq-summary-box">
    <h1 [innerHtml]="summaryBox.title"></h1>
    <span>{{ summaryBox.text }}</span>
  </div>
</div>
